import React from 'react';
import { motion } from 'framer-motion';
import { ArrowRight, ShieldCheck, Lock } from 'lucide-react';
export function FinalCTA() {
  const handleAddToCart = () => {
    if (window.fbq) {
      window.fbq('track', 'AddToCart', {
        content_name: 'Freelance Latina eBook',
        content_type: 'product',
        value: 6.36,
        currency: 'USD'
      });
    }
  };
  return <section className="py-24 relative overflow-hidden bg-gradient-to-br from-[#E8614D] to-[#D4A853] text-white" data-id="element-38">
      {/* Background decoration */}
      <div className="absolute top-0 left-0 w-full h-full opacity-10" style={{
      backgroundImage: 'radial-gradient(circle at 50% 50%, white 2px, transparent 2px)',
      backgroundSize: '40px 40px'
    }} data-id="element-39"></div>

      <div className="container mx-auto px-4 sm:px-6 lg:px-8 relative z-10 text-center" data-id="element-40">
        <motion.div id="precio-final" initial={{
        opacity: 0,
        scale: 0.9
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true
      }} className="max-w-4xl mx-auto bg-white/10 backdrop-blur-md rounded-3xl p-8 md:p-16 border border-white/20 shadow-2xl" data-id="element-41">
          <h2 className="text-4xl md:text-6xl font-bold mb-4" data-id="element-42">
            <span className="line-through opacity-60 text-3xl md:text-4xl" data-id="element-43">
              $17
            </span>{' '}
            <span className="text-[#FFF8F0]" data-id="element-44">$6.36</span>{' '}
            <span className="text-2xl md:text-3xl font-normal opacity-90" data-id="element-45">
              — Descarga Instantánea
            </span>
          </h2>

          <p className="text-xl md:text-2xl mb-10 text-white/90 font-medium" data-id="element-46">
            PDF + Templates + Prompts — Todo listo para empezar HOY
          </p>

          <motion.a whileHover={{
          scale: 1.05
        }} whileTap={{
          scale: 0.95
        }} href="https://coresolutionsg.com/cart/47486657102011:1" target="_blank" rel="noopener noreferrer" onClick={handleAddToCart} className="inline-flex items-center gap-3 bg-white text-[#E8614D] px-10 py-5 rounded-full text-xl md:text-2xl font-bold shadow-xl hover:shadow-2xl transition-all mb-8" data-id="element-47">
            ¡Quiero Mi Sistema Ahora! 🚀
          </motion.a>

          <div className="flex flex-col md:flex-row items-center justify-center gap-6 text-sm md:text-base text-white/80" data-id="element-48">
            <div className="flex items-center gap-2" data-id="element-49">
              <Lock className="w-4 h-4" data-id="element-50" />
              <span data-id="element-51">Pago seguro por Gumroad</span>
            </div>
            <div className="hidden md:block w-1 h-1 bg-white/50 rounded-full" data-id="element-52"></div>
            <div data-id="element-53">Zelle / PayPal</div>
            <div className="hidden md:block w-1 h-1 bg-white/50 rounded-full" data-id="element-54"></div>
            <div className="flex items-center gap-2" data-id="element-55">
              <ShieldCheck className="w-4 h-4" data-id="element-56" />
              <span data-id="element-57">Entrega inmediata</span>
            </div>
          </div>

          <div className="mt-12 pt-8 border-t border-white/20" data-id="element-58">
            <p className="text-lg font-medium animate-pulse" data-id="element-59">
              🔥 Tu primer Reel hoy →{' '}
              <span className="font-bold underline" data-id="element-60">$20 por Zelle mañana</span>
            </p>
          </div>
        </motion.div>
      </div>
    </section>;
}